import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import zhTW from './locales/zh-TW.json';
import en from './locales/en.json';
import hi from './locales/hi.json';
import ru from './locales/ru.json';

// Get stored language or detect browser language
const getDefaultLanguage = () => {
  const stored = localStorage.getItem('language');
  if (stored) return stored;

  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang.startsWith('zh')) return 'zh-TW';
  if (browserLang.startsWith('hi')) return 'hi';
  if (browserLang.startsWith('ru')) return 'ru';

  return 'en'; // Default to English
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'zh-TW': { translation: zhTW },
      'en': { translation: en },
      'hi': { translation: hi },
      'ru': { translation: ru }
    },
    lng: getDefaultLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

// Save language to localStorage on change
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'zh-TW', name: '繁體中文', flag: '🇹🇼' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' }
];

export default i18n;
